<template>
  <div class="d-flex flex-wrap">
    <Selection
      v-if="selectedItems && selectedItems.length"
      class="mb-2"
      :items="selectedItems"
      :loading="loading"
      @remove="handleRemoveItem"
    />
    <SearchPopover
      :options="availableItems"
      :localSearch="localSearch"
      :disabled="disabled"
      :hideSearch="hideSearch"
      :hideIcon="hideIcon"
      :selectionLimit="selectionLimit"
      :value="value"
      :label="label"
      :selectedItems="selectedItems"
      :loading="loading"
      :type="type"
      :zIndex="zIndex"
      @change="handleChangeSelection"
      @search="search"
      @initialLoad="$event => (selectedItems = $event)"
    >
      <v-btn
        rounded
        small
        class="blue-grey--text text--darken-1 body-2 selector-button-trigger"
        color="blue-grey lighten-3"
        elevation="0"
        data-tourid="item-selector-trigger"
        :disabled="disabled"
      >
        <v-icon size="16" class="mr-1" color="blue-grey darken-1">
          mdi-plus
        </v-icon>
        <p class="ma-0">
          {{ buttonCopy }}
        </p>
      </v-btn>
    </SearchPopover>
  </div>
</template>

<script>
import Selection from './Selection.vue'
import SearchPopover from './SearchPopover.vue'
import { fuseSearch } from '@/lib/fuseSearch'
import _ from 'lodash'

export default {
  name: 'MultipleSelector',

  components: {
    Selection,
    SearchPopover,
  },

  props: {
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    localSearch: Boolean,
    disabled: Boolean,
    hideSearch: {
      type: Boolean,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    selectionLimit: {
      type: Number,
      default: 100,
    },
    value: {
      type: Array,
      default: () => [],
    },
    buttonText: {
      type: String,
    },
    loading: Boolean,
    type: String,
    zIndex: Number,
  },

  data() {
    return {
      selectedItems: [],
      availableItems: [],
      cachedItems: {},
      terms: '',
    }
  },

  watch: {
    options: {
      handler(items) {
        if (items.length) {
          this.availableItems = items
          this.addItemsToCache(items)
          this.setSelectedItems()
        }
      },
      immediate: true,
    },

    value: {
      handler(newValue, oldValue) {
        if (!_.isEqual(_.sortBy(newValue), _.sortBy(oldValue)))
          this.setSelectedItems()
      },
      immediate: true,
    },
  },

  computed: {
    buttonCopy() {
      return this.buttonText ?? this.$t('common.assign_options')
    },
  },

  methods: {
    addItemsToCache(items) {
      const hashedItems = _.keyBy(items, 'id')

      const uniqueItems = Object.values(hashedItems).filter(
        newItem => !this.cachedItems[newItem.id]
      )

      this.cachedItems = { ...this.cachedItems, ..._.keyBy(uniqueItems, 'id') }
    },

    search(terms) {
      if (this.localSearch) {
        return (this.availableItems = terms
          ? fuseSearch(this.options, ['title'], terms)
          : this.options)
      }
      this.$emit('search', terms)
    },

    handleRemoveItem(item) {
      this.selectedItems = this.selectedItems.filter(
        selectedOption => selectedOption.id !== item.id
      )
      const newValue = this.selectedItems.map(
        selectedOption => selectedOption.id
      )
      this.$emit('change', newValue)
    },

    handleChangeSelection(event) {
      this.selectedItems = event.items
      this.$emit('change', event.ids)
    },

    setSelectedItems() {
      const cachedItems = _.orderBy(
        _.compact(this.value.map(id => this.cachedItems?.[id] ?? null)),
        item => item.title.toLowerCase(),
        'asc'
      )

      const allItems = [
        ...this.options.filter(option => this.value.includes(option.id)),
        ...cachedItems,
      ]

      this.selectedItems = _.uniqBy(allItems, 'id')
    },
  },
}
</script>

<style>
.v-input.field-to-validate-selection-selected .v-input__control .v-input__slot {
  display: none !important;
}
</style>
